import { gql } from '@apollo/client';
import { useQueryCoordinate, useMutationCoordinate } from '../graphql.hooks';

export const JEDI_RELEASES_GET = gql`
  query JediReleasesGet {
    jediReleasesGet {
      releases {
        releaseKey
        type
        whitelist
        percentage
        salt
        enabled
        createdAt
        updatedAt
      }
    }
  }
`;

export type JediRelease = {
  releaseKey: string;
  type: string;
  whitelist: string[];
  percentage: number;
  salt: string;
  enabled: boolean;
  createdAt: string;
  updatedAt: string;
};

export type JediReleasesGetData = {
  jediReleasesGet: {
    releases: JediRelease[];
  };
};

export const JEDI_RELEASE_UPDATE = gql`
  mutation JediReleaseUpdate($input: JediReleaseUpdateInput!) {
    jediReleaseUpdate(input: $input) {
      success
    }
  }
`;

export type JediReleaseUpdateInput = {
  name: string;
  newWhitelist?: string[];
  newPercentage?: number | null;
  newType?: string;
  enabled?: boolean;
};

export type JediReleaseUpdateData = {
  jediReleaseUpdate: {
    success: boolean;
  };
};

// Custom hook using coordinate
export const useJediReleasesGet = (options = {}) => {
  return useQueryCoordinate(JEDI_RELEASES_GET, options);
};

export const useJediReleaseUpdate = (options = {}) => {
  return useMutationCoordinate(JEDI_RELEASE_UPDATE, options);
}; 